var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewWeek(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3104_2886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 5H3.5C2.95 5 2.5 5.45 2.5 6V18C2.5 18.55 2.95 19 3.5 19H6.5C7.05 19 7.5 18.55 7.5 18V6C7.5 5.45 7.05 5 6.5 5ZM20.5 5H17.5C16.95 5 16.5 5.45 16.5 6V18C16.5 18.55 16.95 19 17.5 19H20.5C21.05 19 21.5 18.55 21.5 18V6C21.5 5.45 21.05 5 20.5 5ZM13.5 5H10.5C9.95 5 9.5 5.45 9.5 6V18C9.5 18.55 9.95 19 10.5 19H13.5C14.05 19 14.5 18.55 14.5 18V6C14.5 5.45 14.05 5 13.5 5Z",
    fill: "#9F9F9F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3104_2886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewWeek);
export default __webpack_public_path__ + "static/media/viewWeek.2da2d1fc7b705e614973152f988696b8.svg";
export { ForwardRef as ReactComponent };